// import { Grid } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
// import { updateMainHeader } from "../../commonFunctions/CommonFunctions";
// import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
// import { useDispatch } from "react-redux";
// import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
// import { IMetaData } from "../../Components/Dialog/WSCommonDialog";
// import { openPopUp } from "../../Components/Dialog/OpenNewModal";
// import WSDataGridNew from "../../Components/DataGrid/WSDataGridNew";
// import WSButton from "../../Components/Button/WSButton";
// import AddIcon from "@mui/icons-material/Add";
// import WSFilterButtonGroup from "../../Components/Filter/WSFilterButtonGroup";
// import PaymentOut from "./PaymentOut";


// export const PaymentOutList: React.FC<any> = React.memo((props) => {

//   const filters = ["All Records"];
//   const [selectedFilter, setSelectedFilter] = useState(filters[0]);

//   useEffect(() => {
//     updateMainHeader("Payment-Out");
//   });

//   breadCrumbsStore.updateBreadCrumbs([
//     { "Payment-Out List": "/payment-out/list" },
//   ]);



//   const columns: IColumns[] = [
//     {
//       header: "Name",
//       fieldName: "specializations",
//       tooltip: true,
//     },

//     {
//       header: "Actions",
//       fieldName: "actions",
//       type: "action",
//       actions: ["Edit", "Delete"],
//     },
//   ];

//   const handleClick = () => {
//     openPopUp(metadata, handleData, "60rem");
//   };
//   const handleData = async (data: any) => {
//     debugger;
//     console.log("onsubmit===>", data); // You can perform any action with the submitted data here
//   };

//   const metadata: IMetaData = {
//     title: "Payment Out",
//     hideActions: false,
//     content: (props: any, row: any) => (
//       <PaymentOut {...props} />
//     ),
//     actions: [
//       {
//         label: "Cancel",
//         // onClick: handleCloseDialog,
//         className: "ws-cancel",
//         type: "button",
//       },
//       {
//         label: "Save",
//         type: "submit",
//         onClick: handleData,
//         autoFocus: true,
//       },
//     ],
//     isDragable: true,
//   };
//   return (
//     <Grid p={3}>
//       <Grid container spacing={2}>

//         <Grid item xs={12}>
//           <WSDataGrid
//             id="paymentoutGrid"
//             title="Payment-Out"
//             columns={columns}
//             searchBox={{ fieldName: "specializations" }}
//             addButton={{ label: "Add Payment-Out", color: "secondary" }}
//             onAddButtonClick={handleClick}
//             gridHeaderSx={{
//               backgroundColor: "whitesmoke",
//               border: "1px solid whitesmoke",
//             }}
//           />
//         </Grid>
//       </Grid>
//     </Grid>


//   );
// });



import { Grid } from "@mui/material";
import React, { useState, useCallback, useRef, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import { updateMainHeader } from "../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { IMetaData } from "../../Components/Dialog/WSCommonDialog";
import { openPopUp } from "../../Components/Dialog/OpenNewModal";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";
import { resetDataComponent } from "../../StateManagement/actions";
import WSButton from "../../Components/Button/WSButton";
import PaymentOut from "./PaymentOut";
import { Method, callAPI } from "../../commonFunctions/CommonFunctions";

export const PaymentOutList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("All Records");
  const [loading, setLoading] = useState(false);
  const [parties, setParties] = useState<any[]>([]);
  const [partyLoading, setPartyLoading] = useState(true);
  const selectedIdRef = useRef<string>("");

  const filters = ["All Records"];

  // Load parties for dropdown
  useEffect(() => {
    const loadParties = async () => {
      try {
        setPartyLoading(true);
        const partyResponse = await callAPI("Vyapar/Party", Method.GET);
        const partyData = Array.isArray(partyResponse.data || partyResponse) 
          ? partyResponse.data || partyResponse 
          : [];
        setParties(partyData);
        console.log("the party name is ",partyData)
      } catch (error) {
        console.error("Failed to load parties:", error);
        showMessage("Failed to load parties", "error");
      } finally {
        setPartyLoading(false);
      }
    };
    loadParties();
  }, [showMessage]);

  // Party options for dropdown
  const partyOptions = useMemo(() => 
    parties.map((party: any) => ({
      id: party.id,
      label: party.partyName || party.name || "Unknown Party",
      value: party.id
    })), 
  [parties]);

  useEffect(() => {
    updateMainHeader("Payment-Out");
    breadCrumbsStore.updateBreadCrumbs([
      { "Payment-Out List": "/payment-out/list" },
    ]);
  }, []);

  const source = {
    url: "Vyapar/PaymentOut/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
  };

  const handleAction = useCallback(async (action: string, row: any) => {
  if (action === "Edit") {
    try {
      const response = await callAPI(`Vyapar/PaymentOut/${row.id}`, Method.GET);
      const paymentData = Array.isArray(response.data || response) 
        ? response.data[0] || response[0] 
        : response.data || response;
      
      // ✅ FIXED: Pass rowData directly with original row.id
      openPopUp(
        metadata(paymentData, row.id), 
        (formData: any) => handleData(formData, { id: row.id, ...paymentData }), 
        "60rem"
      );
    } catch (error) {
      console.error("Failed to load payment data:", error);
      showMessage("Failed to load payment data", "error");
    }
  } else if (action === "Delete") {
    selectedIdRef.current = row.id;
    setPopupOpen(true);
  }
}, [partyOptions]);

  const columns: IColumns[] = [
    {
      header: "Bill No",
      fieldName: "billNo",
    },
    {
      header: "Vendor Name", 
      fieldName: "partyName",
      tooltip: true,
    },
    {
      header: "Paid",
      fieldName: "paid",
    },
    {
      header: "Bill Date",
      fieldName: "billDate",
      type: "date",
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: handleAction,
    },
  ];

  const handleData = async (data: any, rowData?: any) => {
  try {
    const formData = new FormData();
    const partyId = data.party;
    
    formData.append("PartyId", partyId || "");
    formData.append("BillNo", data.billNo || "");
    formData.append("BillDate", data.billDate ? new Date(data.billDate).toISOString().split('T')[0] : new Date().toISOString().split('T')[0]);
    formData.append("Paid", (parseFloat(data.paid || "0") || 0).toString());
    formData.append("Description", data.description || "");

    // ✅ FIX: Add payment lines ONLY if they exist
    const paymentRowsData = data.paymentRows || [];
    paymentRowsData.forEach((payment: any, index: number) => {
      formData.append(`Payments[${index}].PaymentType`, payment.paymentType || "");
      formData.append(`Payments[${index}].Amount`, (parseFloat(payment.amount || "0") || 0).toString());
    });

    // ✅ Handle file upload properly
    const imageFiles = data.image;
    if (imageFiles && Array.isArray(imageFiles) && imageFiles[0]) {
      formData.append("BillFilePath", imageFiles[0]);
    }

    // ✅ FIXED: Correct API endpoint logic
    let apiEndpoint;
    let method;
    
    if (rowData?.id) {
      // UPDATE
      apiEndpoint = `Vyapar/PaymentOut/update/${rowData.id}`;
      method = Method.PUT;
      console.log("🔄 UPDATING with ID:", rowData.id);
    } else {
      // CREATE
      apiEndpoint = "Vyapar/PaymentOut/create";
      method = Method.POST;
      console.log("➕ CREATING new payment");
    }

    console.log("📤 API Endpoint:", apiEndpoint, "Method:", method);
    console.log("📋 FormData contents:", Object.fromEntries(formData));

    setLoading(true);
    const response = await callAPI(apiEndpoint, method, formData);
    
    const message = rowData?.id ? "Payment updated successfully!" : "Payment created successfully!";
    showMessage(`✅ ${message}`, "success");
    dispatch(resetDataComponent("paymentoutGrid"));
    
  } catch (error: any) {
    console.error("❌ Error saving payment:", error);
    console.error("❌ Response data:", error.response?.data);
    showMessage(error.response?.data?.message || "Failed to save payment", "error");
  } finally {
    setLoading(false);
  }
};


  const metadata = (rowData?: any, rowId?: string): IMetaData => ({
  title: rowId ? "Edit Payment Out" : "Payment Out",
  hideActions: false,
  content: (props: any, row: any) => (
    <PaymentOut 
      {...props} 
      id={rowId} 
      rowData={rowData} 
      partyOptions={partyOptions}
    />
  ),
  actions: [
    {
      label: "Cancel",
      className: "ws-cancel",
      type: "button",
    },
    {
      label: "Save",
      type: "submit",
      onClick: handleData,
      autoFocus: true,
      
    },
  ],
  isDragable: true,
});



  const handleClick = () => {
  if (partyLoading) {
    showMessage("Please wait, loading parties...", "warning");
    return;
  }
  openPopUp(
    metadata(null,), 
    handleData, 
    "60rem"
  );
};

  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="paymentoutGrid"
            title="Payment-Out"
            columns={columns}
            source={source}
            searchBox={{ fieldName: "billNo" }}
            addButton={{ label: "Add Payment-Out", color: "secondary" }}
            onAddButtonClick={handleClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
      </Grid>

      <ConfirmationPopup
        type="DELETE"
        apiUrl="Vyapar/PaymentOut"
        id={selectedIdRef.current}
        confirmMessage="Are you sure you want to delete this payment?"
        open={isPopupOpen}
        onClose={() => setPopupOpen(false)}
        onConfirm={(data: any) => {
          dispatch(resetDataComponent("paymentoutGrid"));
          showMessage(
            data?.success ? data.message : data.message || "Delete failed", 
            data?.success ? "success" : "error"
          );
        }}
      />
    </Grid>
  );
});

export default PaymentOutList;
